import { render, staticRenderFns } from "./MNPartnerTariffs.vue?vue&type=template&id=33c6596f&"
import script from "./MNPartnerTariffs.vue?vue&type=script&lang=ts&"
export * from "./MNPartnerTariffs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports